var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_4797)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.8343C6.77834 10.8343 4.16667 13.4459 4.16667 16.6676V18.3343C4.16667 18.7945 3.79357 19.1676 3.33333 19.1676C2.8731 19.1676 2.5 18.7945 2.5 18.3343V16.6676C2.5 12.5255 5.85786 9.1676 10 9.1676C14.1421 9.1676 17.5 12.5255 17.5 16.6676V18.3343C17.5 18.7945 17.1269 19.1676 16.6667 19.1676C16.2064 19.1676 15.8333 18.7945 15.8333 18.3343V16.6676C15.8333 13.4459 13.2217 10.8343 10 10.8343Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.16768C11.8409 9.16768 13.3333 7.6753 13.3333 5.83435C13.3333 3.9934 11.8409 2.50102 10 2.50102C8.15905 2.50102 6.66667 3.9934 6.66667 5.83435C6.66667 7.6753 8.15905 9.16768 10 9.16768ZM10 10.8344C12.7614 10.8344 15 8.59578 15 5.83435C15 3.07293 12.7614 0.834351 10 0.834351C7.23858 0.834351 5 3.07293 5 5.83435C5 8.59578 7.23858 10.8344 10 10.8344Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_4797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.ef8b3b172f23665da33a6ec13d4c254a.svg";
export { ForwardRef as ReactComponent };